interface HintIconProps {
  size?: number;
  className?: string;
}

const HintIcon: React.FC<HintIconProps> = ({ size = 24, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="hintGlow" cx="50%" cy="40%" r="50%">
          <stop offset="0%" stopColor="#fde68a" stopOpacity="0.7" />
          <stop offset="100%" stopColor="#fde68a" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx="12" cy="10" r="10" fill="url(#hintGlow)" />
      <path
        d="M12 1C7.58 1 4 4.58 4 9c0 2.96 1.62 5.54 4 6.93V18.5a1 1 0 001 1h6a1 1 0 001-1v-2.57c2.38-1.39 4-3.97 4-6.93 0-4.42-3.58-8-8-8z"
        fill="#facc15"
        stroke="#d97706"
        strokeWidth="0.5"
      />
      <path d="M8.5 21h7" stroke="#d97706" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M9 23h6" stroke="#d97706" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M9 25h6" stroke="#d97706" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M10 27h4" stroke="#d97706" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="12" cy="8" r="4.5" fill="#fff" opacity="0.5" filter="url(#filamentGlow)" />
      <defs>
        <filter id="filamentGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2" />
        </filter>
      </defs>
      <path
        d="M12 5.5v4M9.5 9.5h5"
        stroke="#fff"
        strokeWidth="1.6"
        strokeLinecap="round"
        filter="url(#filamentSoft)"
      />
      <defs>
        <filter id="filamentSoft">
          <feGaussianBlur stdDeviation="0.4" />
        </filter>
      </defs>
    </svg>
  );
};

export default HintIcon;
